import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import { formatSubscriptionExpiry } from "../utils/userProfile";

export default function KeyAvaileble({ limit, businessSubscription }) {
  const learnerCount = limit ?? 0;
  const businessActiveUntil = formatSubscriptionExpiry(businessSubscription);
  const isLow = learnerCount < 5 && !businessActiveUntil;

  return (
    <div className="app-keys">
      <div className="app-keys__info">
        <div className="app-keys__balances">
          <div className="app-keys__balance">
            <VpnKeyOutlinedIcon className="app-keys__icon" fontSize="small" />
            <span className="app-keys__label">Одноразовые</span>
            <span
              className={`app-keys__count ${
                isLow ? "app-keys__count--low" : "app-keys__count--ok"
              }`}
            >
              {learnerCount}
            </span>
          </div>
          <div className="app-keys__balance app-keys__balance--business">
            <BusinessOutlinedIcon className="app-keys__icon" fontSize="small" />
            <span className="app-keys__label">Групповой</span>
            <span
              className={`app-keys__count ${
                businessActiveUntil
                  ? "app-keys__count--ok"
                  : "app-keys__count--low"
              }`}
            >
              {businessActiveUntil ?? "—"}
            </span>
          </div>
        </div>
      </div>
      <Link to="/main/price" style={{ textDecoration: "none" }}>
        <Button
          variant="contained"
          size="small"
          className="app-btn app-btn--primary app-btn--compact"
        >
          Тарифы
        </Button>
      </Link>
    </div>
  );
}
